exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n    cursor: pointer;\n}\n\n.loginButton {\n    cursor: pointer;\n    color: white;\n    display: block;\n    position: relative;\n    padding: 12px 24px;\n}\n\n.googleLogin {\n    background: #dd4b39;\n}\n\n.facebookLogin {\n    background: #3b5998;\n}\n\n.twitterLogin {\n    background: #00aced;\n}\n\n.githubLogin {\n    background: #333;\n}\n\n.spacerLogin {\n    padding-top: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/authentication/login/login.component.css
// module id = ../../../../../src/app/authentication/login/login.component.css
// module chunks = main